export class LotInfoReportReq{
    plantId : number;
    lotFromDate : any;
    lotToDate : any;
    lotNumber : any;
    workOrderNumber : any;

    constructor(plantId : number,lotFromDate : any,lotToDate : any,lotNumber : any,workOrderNumber : any){
        this.plantId = plantId
        this.lotFromDate = lotFromDate
        this.lotToDate = lotToDate
        this.lotNumber = lotNumber
        this.workOrderNumber = workOrderNumber
    }
}